import { BaseInput } from "shared/components/forms/BaseInput";

export const DatePreview = ({
  value,
  onChange
}: {
  value: string;
  onChange: (value: string) => void;
}) => {
  const parts = value.split("/");
  const month = parts[0] || "";
  const day = parts[1] || "";
  const year = parts[2] || "";

  const update = (m: string, d: string, y: string) => {
    onChange(`${m}/${d}/${y}`);
  };

  return (
    <div className="flex items-end">
      <BaseInput
        id="preview-month"
        label="Month"
        className="w-[80px]"
        placeholder="MM"
        hideOptional
        value={month}
        onChange={(v) => update(v, day, year)}
        maxLength={2}
      />
      <i className="text-[40px] w-[52px] text-center translate-y-1">/</i>
      <BaseInput
        id="preview-day"
        label="Day"
        className="w-[80px]"
        placeholder="DD"
        hideOptional
        value={day}
        onChange={(v) => update(month, v, year)}
        maxLength={2}
      />
      <i className="text-[40px] w-[52px] text-center translate-y-1">/</i>
      <BaseInput
        id="preview-year"
        label="Year"
        className="w-[100px]"
        placeholder="YYYY"
        hideOptional
        value={year}
        onChange={(v) => update(month, day, v)}
        maxLength={4}
      />
    </div>
  );
};
